"use client";

import { useEffect, useRef } from "react";

// Enregistre discrètement une lecture d'article (utilisateur connecté).
// Aucune UI, fire-and-forget : le back dédoublonne à une vue par jour.
const ArticleViewTracker = ({ articleId }) => {
    const sent = useRef(false);

    useEffect(() => {
        if (!articleId || sent.current) return;
        sent.current = true;

        fetch("/api/articles/view", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ articleId }),
            keepalive: true,
        }).catch(() => {});
    }, [articleId]);

    return null;
};

export default ArticleViewTracker;
